const CURRENT_TAB = {
    calculationParameters: 'Параметры расчета',
    results: 'Результаты',
};

const LEFT_WIDGET = {
    spreadsheets: 'Таблицы',
    charts: 'Графики',
};

const RIGHT_WIDGET = {
    GUR: 'НИЗ',
    injectBalance: 'Закачка - Компенсация',
    productionPumping: 'Добычка - Прокачка',
};

const PAGE_WIDGET_WIDTH = {
    FULL: 'w-full',
    HALF: 'w-1/2',
    THIRD: 'w-1/3',
    TWO_THIRDS: 'w-2/3',
};

const PAGE_WIDGET_HEIGHT = {
    FULL: 'h-full',
    HALF: 'h-1/2',
};

const CALCULATION_STEPS = [
    { value: 12, label: 'По годам' },
    { value: 6, label: 'По полугодиям' },
    { value: 3, label: 'По кварталам' },
    { value: 1, label: 'По месяцам' },
];

const DEFAULT_PARAMETERS_FOR_SOLVING = {
    stratumsData: [],
    calculationStep: CALCULATION_STEPS[0].value, // 1, 3, 6, 12 - месяц, квартал, полугодие и год соотвественно,
    useError: false,
    firstDate: null,
    secondDate: null,
    forecastPeriod: null,
    stepFluid: parseFloat('43.00'),
    lastDot: false,
    multiplier: parseFloat('1000000.00'),
    oilConversionFactor: parseFloat('1.0'),
    waterConversionFactor: parseFloat('1.0'),
    balanceReserves: parseFloat('442331000.00'),
    oilRecoveryFactor: parseFloat('0.42'),
    limitWateringCutting: parseFloat('98.0'),
};

const INDICATORS = {
    base: { id: 'base', name: 'Основные показатели', xAxisType: 'linear' },
    waterCut: { id: 'waterCut', name: 'Показатели, обводнённость', xAxisType: 'time' },
    waterCutCumSum: { id: 'waterCutCumSum', name: 'Накопленные, обводнённость', xAxisType: 'time' },
    debitWaterCut: { id: 'debitWaterCut', name: 'Дебиты, обводнённость', xAxisType: 'time' },
    orfWaterCut: { id: 'orfWaterCut', name: 'КИН, обводнённость', xAxisType: 'linear' },
    upTake: { id: 'upTake', name: 'Отборы', xAxisType: 'time' },
    owr: { id: 'owr', name: 'ВНФ', xAxisType: 'time' },
    tempGur: { id: 'tempGur', name: 'Темпы, НИЗ', xAxisType: 'linear' },
    upTakeWaterCut: { id: 'upTakeWaterCut', name: 'Отбор от НИЗ, обводнённость', xAxisType: 'linear' },
};

const STEPS_INITIAL_STATE = {
    govorovaRyabinina: { header: [], rows: [] },
    maximov: { header: [], rows: [] },
    frenchInstitute: { header: [], rows: [] },
    nazarovSipachev: { header: [], rows: [] },
    sipachevPasevich: { header: [], rows: [] },
    modSipachevPasevich1: { header: [], rows: [] },
    modNazarovSipachev: { header: [], rows: [] },
    modSipachevPasevich2: { header: [], rows: [] },
    pirverdyan: { header: [], rows: [] },
    kambarov: { header: [], rows: [] },
    sazonov: { header: [], rows: [] },
    abyzbaev: { header: [], rows: [] },
    arps: { header: [], rows: [] },
    gaisin: { header: [], rows: [] },
    gaisinTimashov: { header: [], rows: [] },
    stasenkov: { header: [], rows: [] },
    revenko: { header: [], rows: [] },
    leonov: { header: [], rows: [] },
    medvedsky: { header: [], rows: [] },
    tkachenko: { header: [], rows: [] },
    ostrovskyDzhaparov1: { header: [], rows: [] },
    ostrovskyDzhaparov2: { header: [], rows: [] },
    ostrovskyDzhaparov3: { header: [], rows: [] },
    grigoriev: { header: [], rows: [] },
    movmygaCherepakhin: { header: [], rows: [] },
    ershagiOmorij: { header: [], rows: [] },
};

const ALLOWED_NODES = ['organization', 'company', 'field', 'pad', 'group'];

const LIST_ITEM_BG = ['bg-white dark:bg-block-secondary', 'bg-white dark:bg-fill-quarternary'];

const SELECTED_LIST_ITEM_BG = 'bg-accent-tean text-white';

export {
    LEFT_WIDGET,
    RIGHT_WIDGET,
    CURRENT_TAB,
    LIST_ITEM_BG,
    SELECTED_LIST_ITEM_BG,
    CALCULATION_STEPS,
    DEFAULT_PARAMETERS_FOR_SOLVING,
    PAGE_WIDGET_WIDTH,
    PAGE_WIDGET_HEIGHT,
    INDICATORS,
    STEPS_INITIAL_STATE,
    ALLOWED_NODES,
};
